import * as forge from 'node-forge';

export function extractCertificateMetadata(certPem: string) {
  const pki = forge.pki;
  const cert = pki.certificateFromPem(certPem);

  const expirationDate = cert.validity.notAfter;
  const serialNumber = cert.serialNumber;

  const issuer = cert.issuer.attributes
    .map((attr) => `${attr.shortName}=${attr.value}`)
    .join('/');

  const subject = cert.subject.attributes
    .map((attr) => `${attr.shortName}=${attr.value}`)
    .join(',');

  return {
    expirationDate: expirationDate.toISOString(),
    serialNumber: serialNumber.match(/.{1,2}/g)?.join(':') ?? '',
    issuer,
    subject
  };
}
